<h4 mat-dialog-title>Редактирование оборудования</h4>
<app-close-button [formGroup]="itemForm" [dialogRef]="dialogRef"/>
<mat-dialog-content>
    <app-loader [isLoading]="loading()"/>
    <form class="flex-column" [formGroup]="itemForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill">
            <mat-label>Название</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

        <app-common-dropdown [formCtrl]="categoryControl" [label]="'Выберите категорию'" [service]="categorySelectorService"/>

        <mat-form-field appearance="fill">
            <mat-label>Описание</mat-label>
            <input matInput formControlName="description" />
        </mat-form-field>

        <div class="flex justify-between">
            <button mat-stroked-button class="w-40" color="basic" type="button" [disabled]="!item.data.id" (click)="deleteItem(item.data.id)">Удалить</button>
            <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="!itemForm.valid">Сохранить</button>
        </div>
    </form>
</mat-dialog-content>


